/**
 * CommonJS workaround for global Jquery definitions which are required for jquery plugins
 * Decent explanation here: https://github.com/rollup/rollup/issues/592#issuecomment-205783255
 */
import jQuery from 'jquery';

window.jQuery = jQuery;
window.$ = jQuery;
